import find from 'lodash/find';
import * as Reducer from './slice';

export interface IAppState {
  // this feature state
  [Reducer.statePropName]: Reducer.IGroupAdminState;
}

const getFeatureState = (state: IAppState) => state[Reducer.statePropName];

export const hasGroup = (state: IAppState) => getFeatureState(state).hasGroup;

const getGroupInfo = (state: IAppState) => getFeatureState(state).group;

const getGroupMembers = (state: IAppState) => {
  const group = getGroupInfo(state);
  return !group ? [] : group.members;
};

export const getGroupMemberName = (state: IAppState, memberId: number) => {
  if (!hasGroup(state)) {
    return undefined;
  }
  const members = getGroupMembers(state);
  const member = find(members, ['userId', memberId]);
  if (!member) {
    const ownerId = getGroupInfo(state)?.ownerUid;
    if (ownerId === memberId) {
      return 'Owner';
    }
    throw new Error('Group member not found!');
  }
  return member.name;
};

const getGroupTrainingStats = (state: IAppState) => getFeatureState(state).memberStats;

export const getGroupMemberTrainingStats = (state: IAppState, memberId: number) => {
  if (!hasGroup(state)) {
    return undefined;
  }
  const groupStats = getGroupTrainingStats(state);
  if (!groupStats) {
    return undefined;
  }
  return groupStats[memberId];
};
